import styled from 'styled-components';

const PanelContentWrapper = styled.div`
    padding: 10px 20px 30px;
    height: 100%;
    margin: 20px 20px 20px 40px;
`;
export default PanelContentWrapper;
